import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";
import DataTableComponent from "../../tools/DataTableComponent";
import * as Yup from "yup";
import "../Validations/errors.css";
import dayjs from 'dayjs';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ReleveFilters from "./ReleveFilters";


const baseUrl = process.env.REACT_APP_BASE_URL;


const Releves = ({ tierLabel, tiersApi }) => {

    const [releves, setReleves] = useState([]);
    const initialFilters = {
        tierId: "",
        dateDebut: "",
        dateFin: "",
        documentType: ""
    };
    const [filters, setFilters] = useState(initialFilters);
    const [dateDebut, setDateDebut] = useState("");
    const [dateFin, setDateFin] = useState("");

    const [tiers, setTiers] = useState([]);
    const isClient = tierLabel === "Client";
    const documentTypes = isClient
        ? [
            { value: "Facture", label: "Factures" },
            { value: "BL", label: "Bons de Livraison" }
        ]
        : [
            { value: "FactureAchat", label: "Factures" },
            { value: "BRA", label: "Bons de Réception" }
        ];

    useEffect(() => {
        fetchTiers();
        //fetchReleves();
    }, []);
    function convertToInputDateFormat(dateStr) {
        // Attend une date au format dd/MM/yyyy
        const [day, month, year] = dateStr.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    const fetchTiers = () => {
        axiosInstance.get(`${baseUrl}/api/${tiersApi}`)
            .then(res => setTiers(res.data))
            .catch(() => console.log("Impossible de charger les données"));
    };
    const fetchReleves = async () => {

        if (!filters.tierId) {
            Swal.fire(
                "Attention",
                `${tierLabel} obligatoire`,
                "warning"
            );
            return;
        }

        try {

            const res = await axiosInstance.get(
                `${baseUrl}/api/Payments/Releves`,
                {
                    params: {
                        clientId: isClient ? filters.tierId : 0,
                        supplierId: !isClient ? filters.tierId : 0,
                        dateDebut: filters.dateDebut,
                        dateFin: filters.dateFin,
                        documentType: filters.documentType

                    }
                }
            );

            const data = res.data.map(x => ({
                ...x,
                dateOperation: dayjs(x.dateOperation)
                    .format("DD/MM/YYYY")
            }));

            setReleves(data);

        } catch {

            Swal.fire(
                "Erreur",
                "Impossible de charger le relevé",
                "error"
            );
        }
    };

    const generatePdf = () => {

        if (!releves.length) {
            Swal.fire(
                "Attention",
                "Aucune donnée à imprimer",
                "warning"
            );
            return;
        }

        const tierName =
            tiers.find(
                x => x.id === Number(filters.tierId)
            )?.name || "";

        exportRelevePdf(
            tierName,
            releves,
            filters.dateDebut,
            filters.dateFin
        );
    };

    const exportRelevePdf = (
        tierName,
        releve,
        dateDebut,
        dateFin
    ) => {

        const doc = new jsPDF();

        const pageWidth = doc.internal.pageSize.getWidth();

        // =====================
        // Logo
        // =====================

        const logoPath =
            `${process.env.PUBLIC_URL}/dist/img/logo_ecogen.png`;

        doc.addImage(
            logoPath,
            "PNG",
            10,
            5,
            40,
            30
        );

        // =====================
        // Titre
        // =====================

        doc.setFontSize(18);
        doc.setFont("helvetica", "bold");

        doc.text(
            isClient ? "RELEVE CLIENT" : "RELEVE FOURNISSEUR",
            pageWidth / 2,
            20,
            { align: "center" }
        );

        // =====================
        // Infos
        // =====================

        doc.setFontSize(11);
        doc.setFont("helvetica", "normal");

        doc.text(
            `${tierLabel} : ${tierName}`,
            14,
            45
        );

        let periode = "";

        if (dateDebut && dateFin)
            periode = `Du ${dayjs(dateDebut).format("DD/MM/YYYY")} au ${dayjs(dateFin).format("DD/MM/YYYY")}`;
        else if (dateDebut)
            periode = `À partir du ${dayjs(dateDebut).format("DD/MM/YYYY")}`;
        else if (dateFin)
            periode = `Jusqu'au ${dayjs(dateFin).format("DD/MM/YYYY")}`;
        else
            periode = "Toutes les périodes";

        doc.text(periode, 14, 52);

        // =====================
        // Tableau
        // =====================


        // =====================
        // Changements V2
        // =====================
        const rows = [];

        releve.forEach(x => {

            rows.push([
                x.dateOperation,
                `${x.paymentMode ? `${x.paymentMode} - ` : ""}${x.type} ${x.numero}`,
                x.debit > 0 ? x.debit.toFixed(2) : "",
                x.credit > 0 ? x.credit.toFixed(2) : ""
            ]);
            if (x.details && x.details.length > 0) {

                rows.push([
                    "",
                    "Désignation",
                    "Qté",
                    "Prix",
                    "Total"
                ]);

                x.details.forEach(d => {

                    rows.push([
                        "",
                        "   • " + d.designation,
                        d.quantite,
                        d.prix,
                        d.total
                    ]);

                });

            }

        });

        autoTable(doc, {
    startY: 65,

    head: [["Date", "Opération", "Débit", "Crédit"]],

    body: rows,

    styles: {
        fontSize: 9,
        lineColor: [180, 180, 180],
        lineWidth: 0.15,
        valign: "middle"
    },

    headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: "bold"
    },

    alternateRowStyles: {
        fillColor: [255, 255, 255]   // supprimer le gris automatique
    },

    didParseCell: function (data) {

        if (data.section !== "body")
            return;

        const firstColumn = data.row.cells[1]?.raw;

        // ===========================
        // Ligne Facture / BL
        // ===========================
        if (
            firstColumn &&
            !firstColumn.startsWith("Désignation") &&
            !firstColumn.startsWith("   •")
        ) {

            data.cell.styles.fillColor = [255, 255, 255];
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.lineWidth = 0.3;
        }

        // ===========================
        // Entête du détail
        // ===========================
        if (firstColumn === "Désignation") {

            data.cell.styles.fillColor = [240, 240, 240];
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fontSize = 8;
        }

        // ===========================
        // Lignes détail
        // ===========================
        if (
            firstColumn &&
            firstColumn.startsWith("   •")
        ) {

            data.cell.styles.fillColor = [255, 255, 255];
            data.cell.styles.fontStyle = "normal";
            data.cell.styles.fontSize = 8;
            data.cell.styles.textColor = [70, 70, 70];
        }
    }
});

        // =====================
        // Fin Changements V2
        // =====================

        // =====================
        // Totaux
        // =====================

        const totalDebit =
            releve.reduce(
                (sum, x) => sum + x.debit,
                0
            );

        const totalCredit =
            releve.reduce(
                (sum, x) => sum + x.credit,
                0
            );

        const soldeFinal =
            totalDebit - totalCredit;

        const finalY =
            doc.lastAutoTable.finalY + 10;

        autoTable(doc, {
            startY: finalY,

            head: [[
                "Total Débit",
                "Total Crédit",
                "Solde"
            ]],

            body: [[
                totalDebit.toFixed(2),
                totalCredit.toFixed(2),
                soldeFinal.toFixed(2)
            ]],

            styles: {
                fontSize: 10
            },

            tableWidth: 90,

            margin: {
                left: pageWidth - 104
            }
        });

        doc.save(
            `Releve_${tierName}.pdf`
        );
    };

    return (

        <div className="container-fluid mt-4">
            <ReleveFilters
                filters={filters}
                setFilters={setFilters}
                onSearch={fetchReleves}
                tierLabel={tierLabel}
                tiers={tiers}
                documentTypes={documentTypes}
            />
            <h3 className="text-center my-3">Gestion des Relevés</h3>

            <button
                className="btn btn-success mb-3"
                onClick={generatePdf}
            >
                <i className="fas fa-file-pdf me-2"></i>
                Générer PDF
            </button>

            <DataTableComponent
                data={releves}
                title="Aperçu du relevé"
                keyField="numero"
                columns={[
                    "dateOperation",
                    "type",
                    "numero",
                    "debit",
                    "credit"
                ]}
                columnsMapping={{
                    dateOperation: "Date",
                    type: "Type",
                    numero: "Document",
                    debit: "Débit",
                    credit: "Crédit"
                }}
            />
        </div>
    );
};

export default Releves;